import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";

export function DeskMonthPanel() {
  const d = new Date(); d.setMonth(d.getMonth() - 1);
  const [ym, setYm] = useState(d.toISOString().slice(0, 7));
  const [lang, setLang] = useState("en");
  const [img, setImg] = useState(null);
  const [busy, setBusy] = useState("");
  const preview = async (l = lang) => {
    setBusy("p"); setLang(l);
    try { const r = await api.get(`/admin/desk-month/preview.png?ym=${ym}&lang=${l}`, { responseType: "blob" }); setImg((old) => { if (old) URL.revokeObjectURL(old); return URL.createObjectURL(r.data); }); }
    catch { toast.error("Couldn't render the card"); } finally { setBusy(""); }
  };
  const post = async () => {
    if (!window.confirm(`Post the ${ym} Monthly Desk Card (English + Spanish) to the Discord recap channels now?`)) return;
    setBusy("s");
    try { const r = await api.post(`/admin/desk-month/post?ym=${ym}`); r.data.posted ? toast.success("Posted to Discord") : toast.error(r.data.reason); }
    catch { toast.error("Post failed"); } finally { setBusy(""); }
  };
  return (
    <Card className="p-5 space-y-4" data-testid="desk-month-panel">
      <div>
        <div className="font-bold text-slate-900">Monthly Desk Card</div>
        <div className="text-xs text-slate-500">Auto-posts on the 1st at 7pm ET (English in #weekly-recap + #the-pit, Spanish in #resumen-semanal + #the-pit-espanol)</div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Input type="month" value={ym} onChange={(e) => setYm(e.target.value)} className="w-40 h-9" data-testid="desk-month-ym" />
        <Button size="sm" variant={lang === "en" && img ? "default" : "outline"} disabled={!!busy} onClick={() => preview("en")} data-testid="desk-month-preview">{busy === "p" && lang === "en" ? "Rendering…" : "Preview EN"}</Button>
        <Button size="sm" variant={lang === "es" && img ? "default" : "outline"} disabled={!!busy} onClick={() => preview("es")} data-testid="desk-month-preview-es">{busy === "p" && lang === "es" ? "Rendering…" : "Preview ES"}</Button>
        <Button size="sm" disabled={!!busy} onClick={post} className="bg-amber-500 hover:bg-amber-600 text-slate-900" data-testid="desk-month-post">Post now</Button>
      </div>
      {img && <img src={img} alt="Monthly desk card preview" className="w-full max-w-3xl rounded-lg border border-slate-200" data-testid="desk-month-img" />}
    </Card>
  );
}
